export const VIDEO_EMBEDDED = {
  ratio: 0.56,
  defaultHeight: 411,
  fullScreen: '"fullscreen;"',

  ANALYTICS: {
    VIDEO_EVENT_GAME_STATUS: {
      BEFORE: 0,
      AFTER: 1,
      LIVE: 2
    },

    VIDEO_EVENT_IS_PREVIEW_STATUS: {
      ON_CLICK: 0,
      AUTO_PLAY: 1,
    },
    YT: {
      PlayerState: {
        UNSTARTED: -1,
        ENDED: 0,
        PLAYING: 1,
        PAUSED: 2,
        BUFFERING: 3,
        CUED: 5
      }
    }
  },

};